import { render, staticRenderFns } from "./FleetItemPalette.vue?vue&type=template&id=2f9234e4&scoped=true&"
import script from "./FleetItemPalette.vue?vue&type=script&lang=js&"
export * from "./FleetItemPalette.vue?vue&type=script&lang=js&"
import style0 from "./FleetItemPalette.vue?vue&type=style&index=0&id=2f9234e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9234e4",
  null
  
)

export default component.exports